import React, {Component} from 'react';
import data from './feedback.json';
import './Dialogs.min.css';

export class FeedbackDialog_1 extends Component {
    constructor(props) {
        super(props);
        //clear state every time feedback button is pressed
        var newData = data.feedback;
        for(var i=0; i < newData.length; i++){
            newData[i].selected = null;
        }
        this.state = {
            data: newData
        };
    }
    selectChoice(index, selected){
        var newData = this.state.data;
        newData[index].selected = selected;
        this.setState({
            data: newData
        })
    }
    saveFeedback(){
        //validate that feedback occurred
        var valid = true;
        for(var i=0; i < this.state.data.length; i++){
            if(!this.state.data[i].selected){
                document.querySelector("#dlg_fb_" + i).classList.add("dlg_error");
                valid = false;
            }
        }

        if(valid){
            var html = "";
            for(i = 0; i < this.state.data.length; i++){
                html+="<div style='font-weight:700'>Question: " + this.state.data[i].label + "</div>";
                html+="<div>Response: " + this.state.data[i].selected + " (1=low, 10=high)</div>";
                html+="<br />";
            }
            html+="<div style='font-weight:700'>Comments:</div>";
            html+="<div>" + document.querySelector("#dlg_textarea").value + "</div>" ;

            //call email webservice
            const options = {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify({
                    mailfrom: "MTS 3D Studio <design_studio@mts.com>",
                    mailto: "tom.owens@mts.com", //Design_studio@mts.com
                    subject: "User Feedback",
                    header: "Feedback Submission",
                    subtitle: "Feedback submitted by a 3D Studio user",
                    html: html
                })
            };

            fetch(this.props.urlSite + '/nodemailer/server.js', options).catch(err => {
                console.error('Request failed', err)
            });

            //call file saving webservice
            var answers = [];
            answers.push(new Date().toISOString().slice(0,10));
            for(i = 0; i < this.state.data.length; i++){
                answers.push(this.state.data[i].selected);
            }
            answers.push(document.querySelector("#dlg_textarea").value);

            const f_options = {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify({
                    answers: answers.join(",")
                })
            };

            fetch(this.props.urlSite + '/filewriter/server.js', f_options).catch(err => {
                console.error('Request failed', err)
            });

            this.props.onClick('feedback_2');
        }
    }
    render() {
        //clear state each time the Feedback button is selected
        return (
            <div id="dlg_feedback_1" className="dialog">
                <div className="dlg_modal">
                    <div className="dlg_title">
                        <img src="images/mtsLogo.png" />
                        <div className="dlg_title_txt">We value your feedback!</div>
                        <div className="dlg_exit" onClick={() => this.props.onClick(null)}>X</div>
                    </div>
                    <div className="dlg_content">
                        <div className="dlg_white">
                            <div className="dlg_feedback_question">
                                {this.state.data.map((question, index) => <FeedbackQuestion key={index} question={question} selected={question.selected} onClick={(selected) => this.selectChoice(index, selected)}></FeedbackQuestion>)}
                            </div>
                            <div className="dlg_feedback_text">Please share any additional feedback</div>
                            <textarea id="dlg_textarea" className="dlg_input_text"></textarea>
                        </div>
                        <div id="dlg_feedback_btn_1" className="dlg_btn" onClick={() => this.saveFeedback()}>SUBMIT</div>
                    </div>
                </div>
            </div>
        );
    }
}

export class FeedbackDialog_2 extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div id="dlg_feedback_2" className="dialog">
                <div className="dlg_modal">
                    <div className="dlg_title">
                        <img src="images/mtsLogo.png" />
                        <div className="dlg_title_txt">Contact MTS Technical Support</div>
                        <div className="dlg_exit" onClick={() => this.props.onClick(null)}>X</div>
                    </div>
                    <div className="dlg_content">
                        <div className="dlg_white">
                            <p className="dlg_head">Thank you for your input!</p>
                            <p className="dlg_feedback_text">Your input will be used to improve the 3D Studio tool and customer experience.</p>
                        </div>
                        <div id="dlg_feedback_btn_2" className="dlg_btn" onClick={() => this.props.onClick(null)}>CLOSE</div>
                    </div>
                </div>
            </div>
        );
    }
}

class FeedbackQuestion extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        //create ten choices
        var choices = [];
        for(var i = 1; i <= 10; i++){
            choices.push({num: i});
        }
        return (
            <div>
                <div id={"dlg_fb_" + this.props.question.id}>{this.props.question.label}</div>
                <div className="dlg_feedback">
                    {choices.map((choice, index) => <FeedbackChoice key={index} choice={choice} selected={this.props.selected} onClick={(selected) => this.props.onClick(selected)}></FeedbackChoice>)}
                    <br clear="all" />
                    <div className="dlg_fb_label">Not At All Satisfied</div>
                    <div className="dlg_fb_label">Extremely Satisfied</div>
                </div>
            </div>
        );
    }
}

class FeedbackChoice extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className={"dlg_fb_btn" + (this.props.choice.num == this.props.selected ? " dlg_fb_selected" : "")} onClick={() => this.props.onClick(this.props.choice.num)}>{this.props.choice.num}</div>
        );
    }
}

export class HelpDialog_1 extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div id="dlg_help_1" className="dialog">
                <div className="dlg_modal">
                    <div className="dlg_title">
                        <img src="images/mtsLogo.png" />
                        <div className="dlg_title_txt">Frequently Asked Questions</div>
                        <div className="dlg_exit" onClick={() => this.props.onClick(null)}>X</div>
                    </div>
                    <div className="dlg_content">
                        <div className="dlg_grey">
                            <p>
                               <span className="dlg_strong">Q) I have problems with the Image Previewer showing my Model or accessing content.</span><br />
                               <span>A) Try a different Browser, it is most likely with a specific issue of your computer setup.<br /></span>
                            </p>
                            <p>
                                <span className="dlg_strong">Q) The Image Previewer shows scroll bars or the screen flickers.</span><br />
                                <span>A) Try zooming in or out, changing window size or changing resolution. Also try another browser, it may be again an issue with your computer setup.<br /></span>
                            </p>                            <p>
                                <span className="dlg_strong">Q) Will MTS be adding other key products to MTS 3D Design Studio?</span><br />
                                <span>A) MTS will continue to add new products to the site as they become available.<br /></span>
                            </p>
                            <p>
                                <span className="dlg_strong">Q) I can't find the product option I am looking for. What do I do?</span><br />
                                <span>A) Use the "Request Custom Option" button to contact MTS.<br /></span>
                            </p>
                            <p>
                                <span className="dlg_strong">Q) I can't get 3D Design Studio to work on my mobile device.  What do I do?</span><br />
                                <span>A) MTS is still developing 3D Studio to work for mobile devices.  Until the mobile version is released, MTS recommends using a desktop or laptop.</span><br />
                            </p>
                            <p>
                                <span className="dlg_strong">Q) I submitted a "Request for Quote" request. How soon should I expect a response from MTS?</span><br />
                                <span>A) A MTS Sales person will be contacting you within 24 hours.<br /></span>
                            </p>
                            <p>
                                <span className="dlg_strong">Q) I submitted a CAD request or Save Action, but have not received an email.  What do I do?</span><br />
                                <span>A) An email should arrive in your inbox within 5 minutes. Please check your spam or junk folder.</span><br />
                            </p>

                        </div>
                        <p>
                            <span className="dlg_strong">Need More Help?</span><br />
                            <span className='dlg_hyperlink' onClick={() => this.props.onClick('help_2')}>Contact MTS Support.</span>
                        </p>
                        <div id="dlg_help_btn_1" className="dlg_btn" onClick={() => this.props.onClick(null)}>CLOSE</div>
                    </div>
                </div>
            </div>
        );
    }
}

export class HelpDialog_2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null
        };
    }
    componentDidMount() { //after render
        document.querySelector(".dlg_dropdown").addEventListener("change", this.hideError, false);
    }
    componentWillUnmount() {
        document.querySelector(".dlg_dropdown").removeEventListener("change", this.hideError, false);
    }
    validateInput() {
        var valid = true;
        var error_msg = null;
        var dropdown = document.querySelector(".dlg_dropdown");
        var input = document.querySelector(".dlg_input_text");
        if(dropdown.value == 0){
            valid = false;
            error_msg = "Please select a option from the list above";
        }else if(dropdown.value == 7 && input.value.trim() == ""){
            valid = false;
            error_msg = "Please describe your problem in the text box above";
        }

        this.setState({
            error: error_msg
        });

        if(valid){
            var html = "";
            html+="<div><b>Name:</b> " + this.props.customer.firstName + " " + this.props.customer.lastName + "</div>";
            html+="<div><b>Email:</b> " + this.props.customer.email + "</div>";
            html+="<div><b>Phone:</b> " + this.props.customer.phone + "</div>";
            html+="<div style='margin:1em 0 1em 0;'><b>Type:</b> " + dropdown.options[dropdown.value].innerHTML + "</div>";
            html+="<div><b>Question/Comment:</b> " + input.value + "</div>" ;

            //call email webservice
            const options = {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify({
                    mailfrom: "MTS 3D Studio <design_studio@mts.com>",
                    mailto: "tom.owens@mts.com, jim.hennen@mts.com", //Design_studio@mts.com
                    subject: "User Help Request",
                    header: "User Help Request",
                    subtitle: "Help request by a 3D Studio user",
                    html: html
                })
            };

            fetch(this.props.urlSite + '/nodemailer/server.js', options).catch(err => {
                console.error('Request failed', err)
            });

            this.props.onClick('help_3');
        }
    }
    hideError = () => {
        this.setState({
            error: null
        });
    }
    render() {
        return (
            <div id="dlg_help_2" className="dialog">
                <div className="dlg_modal">
                    <div className="dlg_title">
                        <img src="images/mtsLogo.png" />
                        <div className="dlg_title_txt">Contact MTS Technical Support</div>
                        <div className="dlg_exit" onClick={() => this.props.onClick(null)}>X</div>
                    </div>
                    <div className="dlg_content">
                        <div className="dlg_grey">
                            <p className="dlg_head">Please tell us how we can help.</p>
                            <span className="dlg_label">I need help with . . .</span>
                            <select className="dlg_dropdown">
                                <option value="0"></option>
                                <option value="1">The tool is malfunctioning</option>
                                <option value="2">I am not able to print</option>
                                <option value="3">I am not able to export a CAD file</option>
                                <option value="4">I am not able to save my design</option>
                                <option value="5">I am not able to request a quote</option>
                                <option value="6">I have a product question</option>
                                <option value="7">Other (please describe below)</option>
                            </select>
                            <span className="dlg_label">Comments:</span>
                            <textarea id="dlg_textarea" className="dlg_input_text"></textarea>
                            <div className="dlg_error" style={{fontWeight: "bold", display: this.state.error == null ? "none" : "block"}}>{this.state.error}</div>
                        </div>
                        <div id="dlg_help_btn_2" className="dlg_btn" onClick={() => this.validateInput()}>SUBMIT</div>
                    </div>
                </div>
            </div>
        );
    }
}

export class HelpDialog_3 extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div id="dlg_help_3" className="dialog">
                <div className="dlg_modal">
                    <div className="dlg_title">
                        <img src="images/mtsLogo.png" />
                        <div className="dlg_title_txt">Contact MTS Technical Support</div>
                        <div className="dlg_exit" onClick={() => this.props.onClick(null)}>X</div>
                    </div>
                    <div className="dlg_content">
                        <div className="dlg_white">
                            <p className="dlg_head">Your help request has been received.</p>
                            <p>Your help request will be forwarded to an MTS representative.  The support representative will contact you using the information you provided.</p>
                            <p>MTS support is available Monday thru Friday (excluding holidays) 8 am - 6 pm CST.  You will receive a response within three business hours of your submission.</p>
                            <p>If you have any questions or concerns, please call MTS at: 800-328-2255.</p>
                        </div>
                        <div id="dlg_help_btn_3" className="dlg_btn" onClick={() => this.props.onClick(null)}>CLOSE</div>
                    </div>
                </div>
            </div>
        );
    }
}

export class Popup_Message extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div id="dlg_popup" className="dialog">
                <div className="dlg_modal">
                    <div className="dlg_title">
                        <img src="images/mtsLogo.png" />
                        <div className="dlg_title_txt">Message from 3D Studio</div>
                        <div className="dlg_exit" onClick={() => this.props.onClick(null)}>X</div>
                    </div>
                    <div className="dlg_content">
                        <div className="dlg_white">
                            <p className="dlg_head">Welcome to 3D Studio.</p>
                            <p>This site uses popups which some browsers block by default.  Please enable popups to get the full 3D Studio experience.</p>
                        </div>
                        <div id="dlg_popup_btn" className="dlg_btn" onClick={() => this.props.onClick(null)}>CONTINUE</div>
                    </div>
                </div>
            </div>
        );
    }
}
